/**
 * Módulo: Tabbed Content
 * Troca de painéis ao clicar nos botões da sidebar.
 * No mobile, rola suavemente até o painel ao ativar.
 */

const MOBILE_BP = 767.98;

export function initTabbedContent() {
  const containers = document.querySelectorAll('[data-tabbed-content]:not([data-tabbed-content-initialized])');
  if (!containers.length) return;

  containers.forEach(container => {
    container.setAttribute('data-tabbed-content-initialized', 'true');
    const buttons = container.querySelectorAll('.tabbed-content__nav-btn');
    const panels  = container.querySelectorAll('.tabbed-content__panel');

    if (!buttons.length || !panels.length) return;

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.tabIndex, 10);

        // Desativa todos
        buttons.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
        });

        // Ativa o clicado
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        const targetPanel = container.querySelector(`.tabbed-content__panel[data-tab-panel="${idx}"]`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          // Mobile: scroll até o painel (compensa header fixo)
          if (window.matchMedia(`(max-width: ${MOBILE_BP}px)`).matches) {
            requestAnimationFrame(() => {
              const header = document.getElementById('masthead');
              const headerH = header ? header.getBoundingClientRect().height : 0;
              const offset = Math.max(headerH, 120) + 48;
              const panelRect = targetPanel.getBoundingClientRect();
              const top = panelRect.top + window.scrollY - offset;
              console.log('[tabbed-scroll]', { headerH, offset, panelTop: panelRect.top, scrollY: window.scrollY, scrollTo: top });
              window.scrollTo({ top, behavior: 'smooth' });
            });
          }
        }
      });
    });
  });
}
